import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyleRoot } from 'radium';

import Treebeard from './TreeBeard';
import decorators from './Decorators';
import DraggableNode from './DraggableNode';

import styles from './DynamicTreeStyles';
import * as treeUtils from './DynamicTreeUtils';

import * as messages from './../../../messages/DictionaryMessages';

let useQuestions = false;
// Example: Customising The Header Decorator To Include Icons
decorators.Header = props => {
  const style = props.style;
  let iconType = 'question';
  if (props.node.rectype !== 'Q') {
    if (props.node.toggled) {
      iconType = 'folder-open';
    } else {
      iconType = 'folder';
    }
  }
  const iconClass = `node-icon node-icon-${iconType}`;
  // const iconStyle = { marginRight: '5px' };
  if (iconType === 'question') {
    return (
      <div
        className="define-position"
        data-tooltip
        aria-haspopup="true"
        data-disable-hover="false"
        title={props.node.shortText.toUpperCase()}
      >
        <DraggableNode
          // baseStyle={style.base}
          titleStyle={style.title}
          iconClass={iconClass}
          // iconStyle={iconStyle}
          name={props.node.shortText.toUpperCase()}
          node={props.node}
          useQuestions={useQuestions}
        />
      </div>
    );
  }

  return (
    <div
      className="define-color"
      style={style.base}
      data-tooltip
      aria-haspopup="true"
      data-disable-hover="false"
      title={props.node.shortText.toUpperCase()}
    >
      <div style={style.title}>
        <span className={iconClass} />
        {props.node.shortText.toUpperCase()}
      </div>
    </div>
  );
};

decorators.Header.propTypes = {
  style: PropTypes.shape({}),
  node: PropTypes.shape({
    shortText: PropTypes.string,
    rectype: PropTypes.string,
    toggled: PropTypes.bool,
  }),
};

export default class DynamicTree extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [...this.props.treedata] };
    this.onToggle = this.onToggle.bind(this);
    this.onFilterMouseUp = this.onFilterMouseUp.bind(this);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    useQuestions = nextProps.useQuestions;
    if (this.props.treedata !== nextProps.treedata) {
      this.setState({ data: [...nextProps.treedata] });
    }
  }
  onFilterMouseUp(e) {
    const filter = e.target.value.trim();
    if (!filter) {
      this.setState({ data: [...this.props.treedata] });
    } else {
      // let filtered = filters.filterTree(this.props.treedata, filter);
      // filtered = filters.expandFilteredNodes(filtered, filter);
      // this.setState({ data: filtered });
    }
  }
  onToggle(node, toggled) {
    if (node.recno && node.children) {
      const newNode = treeUtils.findTreeNode(
        this.props.treedata,
        node.recno,
        (n, recno) => n.recno === recno,
      );
      newNode.active = true;
      if (node.rectype !== 'Q') {
        newNode.toggled = toggled;
      }
      this.props.onNodeClicked(
        newNode,
        { recno: this.currentCursor, active: false },
        true,
      );
      this.currentCursor = newNode.recno;
    } else {
      const newNode = treeUtils.findTreeNode(this.props.treedata, node.node);
      newNode.active = true;
      if (node.rectype !== 'Q') {
        newNode.toggled = toggled;
      }
      this.props.onNodeClicked(
        newNode,
        { node: this.currentCursor, active: false },
        false,
      );
      this.currentCursor = newNode.node;
    }
  }
  render() {
    return (
      <StyleRoot>
        <div style={styles.component}>
          {this.state.data.length ? (
            <Treebeard
              data={this.state.data}
              onToggle={this.onToggle}
              tabSelected={this.props.tabSelected}
              decorators={decorators}
            />
          ) : (
            <p>{messages.NODATA_MESSAGE}</p>
          )}
        </div>
      </StyleRoot>
    );
  }
}

DynamicTree.propTypes = {
  onNodeClicked: PropTypes.func,
  treedata: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  tabSelected: PropTypes.string,
};
